<div *ngIf="(show$ | async)">
    <mapa-header></mapa-header>
    <div class="mapa-content-container">
        <router-outlet></router-outlet>
    </div>
</div>
